module.exports = __webpack_public_path__ + "img/open-close_6month01.5f803601.png";